<template>
    <div class="item_sidebar margin_item_sidebar active" >
        <div class="wrapper_title">
            <div class="title">{{title}}</div>
        </div>
        <div class="wrapper_body">
            <div class="left_box">
                <div class="icon_margin">
                    <img :src="require(`@/assets/page/img/${title.toLowerCase()}_icon.svg`)"/>
                </div>
            </div>
            <div class="right_box">
                <div class="field margin_single_side margin_top_side">
                  <div class="title">Top</div>
	                <input-field type="number" append="px" small :step="10" :min="-200000"
	                             v-model.number="compData.top" @input="marginInputChanged($event, 'top')" />
                </div>
                <div id="field1" class="field margin_single_side">
                    <div class="title">Bottom</div>
		                <input-field type="number" append="px" small :step="10" :min="-200000"
		                             v-model.number="compData.bottom" @input="marginInputChanged($event, 'bottom')" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputField from '@/components/base/input-field'
export default {
	name: 'SectionMargin',
	props: ['value', 'title'],
	components: {InputField},
	data: function () {
		return {
			marginFields: {top: 0, bottom: 0},
		}
	},
	computed: {
		compData() {
			this.marginFields = {...this.value};

			return this.marginFields;
		},
	},
	methods: {
		marginInputChanged(val, sideName) {
			this.$set(this.marginFields, sideName, parseInt(val||'0'));
			// Allow sub-zero values.
			this.$emit('updated', this.marginFields);
		},
	},
	created() {
		this.marginFields = JSON.parse(JSON.stringify(this.value));
	},
}
</script>
